import { Tag } from '@cian/components';
import * as React from 'react';

import { ERentTime } from '../../../../json_query';
import { IRentTimeTag } from '../../../state/tags/definitions/rent_time';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IRentTimeTagItemProps {
  tag: IRentTimeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const rentTimeMap = {
  [ERentTime.FromYear]: 'Аренда от года',
  [ERentTime.FewMonths]: 'От нескольких месяцев',
};

export const RentTimeTagItem = ({ tag, onDeleteClick, withNewTag }: IRentTimeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === ERentTime.FromYear || tag.value === ERentTime.FewMonths) {
    return (
      <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
        {rentTimeMap[tag.value]}
      </TagComponent>
    );
  }

  return null;
};
